import React from 'react';
import { Rocket, Link, Eye, ChevronRight } from 'lucide-react';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
      {/* Navigation */}
      <nav className="bg-white shadow">
        <div className="max-w-6xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="text-xl font-bold text-blue-600">Fighting Chance Inc.</div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <main>
        <div className="max-w-6xl mx-auto px-4 py-16">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Web and mobile apps to help bring in eye balls to that amazing thing you're selling!
            </h1>
            <p className="text-xl text-gray-600 mb-8">
              Transform your long, complex URLs into memorable, shareable links that convert.
            </p>
            <button className="bg-blue-600 text-white px-8 py-3 rounded-lg text-lg font-semibold hover:bg-blue-700 transition-colors">
              Get Started
            </button>
          </div>

          {/* Features Section */}
          <div className="mt-24 grid md:grid-cols-3 gap-12">
            <div className="text-center">
              <div className="flex justify-center mb-4">
                <Link className="w-12 h-12 text-blue-600" />
              </div>
              <h3 className="text-xl font-semibold mb-2">Simple URL Shortening</h3>
              <p className="text-gray-600">
                Create memorable, branded links in seconds that your clients will love to share.
              </p>
            </div>

            <div className="text-center">
              <div className="flex justify-center mb-4">
                <Eye className="w-12 h-12 text-blue-600" />
              </div>
              <h3 className="text-xl font-semibold mb-2">Increased Visibility</h3>
              <p className="text-gray-600">
                Make your virtual tours and listings more accessible with easy-to-remember URLs.
              </p>
            </div>

            <div className="text-center">
              <div className="flex justify-center mb-4">
                <Rocket className="w-12 h-12 text-blue-600" />
              </div>
              <h3 className="text-xl font-semibold mb-2">Boost Conversions</h3>
              <p className="text-gray-600">
                Turn complex virtual tour links into professional, branded experiences.
              </p>
            </div>
          </div>

          {/* CTA Section */}
          <div className="mt-24 text-center">
            <h2 className="text-3xl font-bold mb-6">Ready to transform your links?</h2>
            <div className="inline-flex items-center space-x-2 text-blue-600 hover:text-blue-700 cursor-pointer">
              <span className="text-lg font-semibold">Start Your Free Trial</span>
              <ChevronRight className="w-5 h-5" />
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-gray-50 mt-24">
        <div className="max-w-6xl mx-auto px-4 py-8">
          <div className="text-center text-gray-600">
            <p>© 2025 Fighting Chance Inc. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;